export default __webpack_public_path__ + "static/revolutionizing-retail-05950a167b98df2abc8c0b0ebda5143c.png";